"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractUtxoAPI = exports.AbstractJuneoChainAPI = exports.AbstractAPI = void 0;
const client_1 = require("./client");
class AbstractAPI {
    client;
    endpoint;
    service;
    constructor(client, endpoint, service) {
        this.client = client;
        this.endpoint = endpoint;
        this.service = service;
    }
    async callServiceAt(service, endpoint, method, params) {
        return await this.client.rpcCall(`${endpoint}`, new client_1.JsonRpcRequest(`${service}${service.length > 0 ? '.' : ''}${method}`, params));
    }
    async callAt(endpoint, method, params) {
        return await this.callServiceAt(this.service, endpoint, method, params);
    }
    async call(method, params) {
        return await this.callAt(this.endpoint, method, params);
    }
}
exports.AbstractAPI = AbstractAPI;
class AbstractJuneoChainAPI extends AbstractAPI {
    async getTx(txID, encoding) {
        const response = await this.call('getTx', [{ txID, encoding }]);
        return response.result;
    }
    async issueTx(tx, encoding) {
        const response = await this.call('issueTx', [{ tx, encoding }]);
        return response.result;
    }
}
exports.AbstractJuneoChainAPI = AbstractJuneoChainAPI;
class AbstractUtxoAPI extends AbstractJuneoChainAPI {
    async getUTXOs(addresses, limit, startIndex, encoding) {
        const response = await this.call('getUTXOs', [{ addresses, limit, startIndex, encoding }]);
        return response.result;
    }
    async getUTXOsFrom(addresses, sourceChain, limit, startIndex, encoding) {
        const response = await this.call('getUTXOs', [
            { addresses, sourceChain, limit, startIndex, encoding }
        ]);
        return response.result;
    }
}
exports.AbstractUtxoAPI = AbstractUtxoAPI;
